import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { constants, NotificationManager, ResponsibleApi, useSelfRegulation } from '@atlas/core';
import { DefaultPopup, Loader } from '@atlas/ui';

import LimitForm from './LimitForm';

const { SPENT } = constants.SELF_REGULATION_LIMIT;
const CommonSpentLimitPopup = ({ data, id }) => {
  const { checkCommonSpentLimit, setRegulationLimit, state } = useSelfRegulation();

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
    data?.onClosePopup();
  }, [id, data]);

  const handleSubmitPopup = useCallback(() => {
    data?.onSuccessPopup();
    NotificationManager.removeNotification(id);
  }, [data, id]);

  useEffect(() => {
    ResponsibleApi.getClientLossLimits({
      type: SPENT,
    }).then(data => {
      setRegulationLimit(data, SPENT);
    });
  }, [setRegulationLimit]);

  const spentLimit = state[SPENT];

  return (
    <DefaultPopup
      className="spent-limits"
      headerTitle="common_spent_limit_popup_title"
      headerTitleClass="spent-limits__title"
      onClose={handleClose}
    >
      {!spentLimit && <Loader />}
      {spentLimit && (
        <LimitForm
          checkCommonSpentLimit={checkCommonSpentLimit}
          onClosePopup={handleSubmitPopup}
          regulationLimit={spentLimit}
          setRegulationLimit={setRegulationLimit}
          type={SPENT}
        />
      )}
    </DefaultPopup>
  );
};

CommonSpentLimitPopup.propTypes = {
  data: PropTypes.shape({
    onClosePopup: PropTypes.func,
    onSuccessPopup: PropTypes.func,
  }),
  id: PropTypes.string.isRequired,
};

export default CommonSpentLimitPopup;
